import { xor } from './utils/xor';
import type { MailFolderTableQuery, SortBy } from 'owa-mail-list-store';
import { getSafeSelectedTableView, isPriorityView, type TableQueryType } from 'owa-mail-list-store';

export const sortByRestriction = (sortings: SortBy[], shouldHide?: boolean) => (): boolean => {
    const { tableQuery } = getSafeSelectedTableView() || {};
    const type = tableQuery?.type;

    let isSortByInRestrictionList = false;
    if (type == 0 || type == 2) {
        if (isPriorityView(tableQuery as MailFolderTableQuery)) {
            // Priority View bypasses sort restriction
            isSortByInRestrictionList = true;
        } else {
            const tableSortBy = (tableQuery as MailFolderTableQuery).sortBy;
            isSortByInRestrictionList = sortings.some(({ sortColumn, sortDirection }) => {
                return (
                    sortColumn == tableSortBy.sortColumn &&
                    sortDirection == tableSortBy.sortDirection
                );
            });
        }
    } else {
        isSortByInRestrictionList = true;
    }

    return xor(shouldHide, isSortByInRestrictionList);
};
